import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Quote from "./sections/Quote";
import QuoteRequestForm from "./sections/QuoteRequestForm";
import RegionalOffices from "./sections/RegionalOffices";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Quote />
      <QuoteRequestForm />
      <RegionalOffices />
      <Footer />
    </div>;
}